import { render, staticRenderFns } from "./defectGrade.vue?vue&type=template&id=ec68795c&scoped=true&"
import script from "./defectGrade.vue?vue&type=script&lang=js&"
export * from "./defectGrade.vue?vue&type=script&lang=js&"
import style0 from "./defectGrade.vue?vue&type=style&index=0&id=ec68795c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec68795c",
  null
  
)

export default component.exports